import { connect } from "react-redux";
import { compose, withProps } from "recompose";
import Experiences, { ExperiencesProps } from "./Experiences";
import { BoardSlice, loadBoards, selectBoards, selectIsLoadingBoards } from "pods/board";
import { IdeasSlice, selectBoardSlugs } from "src/pods/ideas";

/**
 * @param  {Object} state
 * @return {Object}
 */
function mapStateToProps(state: IdeasSlice & BoardSlice) {
  return {
    boardSlugs: selectBoardSlugs(state) || [],
    boards: selectBoards(state) || [],
    isLoadingBoards: selectIsLoadingBoards(state),
  };
}

type OuterExperiencesProps = Omit<ExperiencesProps, "boardSlugs" | "boards" | "isLoadingBoards" | "loadBoards">;

export default compose<ExperiencesProps, OuterExperiencesProps>(
  withProps<any, any>(({ mountPoint }: { mountPoint: any }) => {
    mountPoint;
  }),
  connect(mapStateToProps, { loadBoards }),
)(Experiences);
